import { useEffect, useRef } from "react";
import jsVectorMap from "jsvectormap";
import "jsvectormap/dist/maps/world.js";
import "jsvectormap/dist/jsvectormap.css";

// Interactive vector map highlighting cities the user has scraped (focused on Indonesia).
export default function DashboardMap({ points = [] }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!elRef.current) return;
    const markers = points
      .filter((p) => typeof p.lat === "number" && typeof p.lng === "number")
      .map((p) => ({ name: `${p.city} — ${p.count} lead (${p.province})`, coords: [p.lat, p.lng] }));

    if (mapRef.current) { try { mapRef.current.destroy(); } catch (e) {} mapRef.current = null; }
    elRef.current.innerHTML = "";

    let map;
    try {
      map = new jsVectorMap({
        selector: elRef.current,
        map: "world",
        zoomButtons: true,
        zoomOnScroll: false,
        backgroundColor: "transparent",
        regionStyle: {
          initial: { fill: "#e2e8f0", stroke: "#ffffff", strokeWidth: 0.4 },
          hover: { fill: "#cbd5e1" },
        },
        markers,
        markerStyle: {
          initial: { fill: "#0ea5e9", stroke: "#ffffff", strokeWidth: 1.5, fillOpacity: 0.9, r: 7 },
          hover: { fill: "#0284c7", stroke: "#ffffff" },
        },
        markersSelectable: false,
      });
      mapRef.current = map;
      // Zoom toward Indonesia after the SVG is ready. animate:false avoids jsvectormap's
      // async transform loop which throws an uncaught error in v1.7.
      setTimeout(() => {
        try { map.setFocus({ coords: [-2.5, 118.0], scale: 4, animate: false }); } catch (e) {}
      }, 400);
    } catch (e) {
      // never let the map crash the dashboard
    }

    return () => { if (mapRef.current) { try { mapRef.current.destroy(); } catch (e) {} mapRef.current = null; } };
  }, [points]);

  return <div ref={elRef} data-testid="dashboard-vector-map" style={{ width: "100%", height: 340 }} />;
}
